import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import ImageBackground from '../common/imageBackground';
import NavigationBar from '../common/navigationBar';
import dwbDimming from './images/DWB-dimming.png';
import './styles.css';

class Service1346 extends Component {
  /**************
   * Properties *
   **************/
  navigationBar = {
    mainMenu: true,
    back: true,
    backRoute: '/main_menu',
  };

  // return home
  handleOnKeyUp = (event) => {
    if (event.key === "Enter") {
      this.props.history.push("/main_menu");
    }
  };
  handleClick = () => {
    this.props.history.push("/main_menu");
  };

  componentWillMount() {
    document.addEventListener("keyup", this.handleOnKeyUp, false);
  }

  componentWillUnmount() {
    document.removeEventListener("keyup", this.handleOnKeyUp);
  }

  /**
   * Renders the component.
   *
   * @public
   *
   * @returns { React.Component }  The rendered view of the component.
   *
   */
  render() {
    return (
      <div className="dwb-dimming">
        <ImageBackground id="background" />
        <img className="dimming" src={dwbDimming} alt="" onClick={this.handleClick}/>
        <NavigationBar {...this.navigationBar} />
      </div>
    );
  }
}

export default withRouter(Service1346);
